import { useState, useEffect, useCallback } from 'react';
import { Property } from '../types';
import { getNewlyAddedPropertiesApi } from '../services/propertyApiClient';

export const useNewlyAddedProperties = (dateStr?: string | null) => {
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProperties = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const results = await getNewlyAddedPropertiesApi(dateStr);
      setProperties(results);
    } catch (err: any) {
      console.error('[useNewlyAddedProperties] Error al cargar inmuebles:', err);
      setError(err?.message || 'No se pudieron cargar los inmuebles recientes.');
    } finally {
      setLoading(false);
    }
  }, [dateStr]);

  useEffect(() => {
    fetchProperties();
  }, [fetchProperties]);

  return { properties, loading, error, refetch: fetchProperties };
};
